export const footerMenuData = {
  nav: [
    {
      text: 'footer_product',
      name: 'product',
      subs: [
        {text: 'menu_templates', href: '/website/templates', target: '_blank', name: 'templates'},
        {text: 'menu_explore', href: '/explore/websites', target: '_blank', name: 'explore'},
        {text: 'sub_menu_features', href: '/features/main', target: '_blank', name: 'features'},
        {text: 'sub_menu_website_builder', href: '/', lang: ['en'], name: 'website_builder'},
        {text: 'footer_web_accesibility', href: 'https://www.wix.com/accessibility', target: '_blank', name: 'web_accesibility'},
        {text: 'sub_menu_velo', href: 'https://www.wix.com/velo', target: '_blank', name: 'velo'},
        {text: 'footer_playground', href: 'https://www.wix.com/playground', target: '_blank', lang: ['en'], name: 'playground'},
        {text: 'menu_my_account', href: '/my-account', target: '_blank', name: 'my_account'},
        {text: 'sub_menu_upgrade_plans', href: '/upgrade/website', target: '_blank', name: 'upgrade_plans'},
        {text: 'footer_seo', href: '/features/wix-seo', target: '_blank', name: 'seo'},
        {text: 'footer_logo_maker', href: '/logo/maker', target: '_blank', name: 'logo_maker'},
        {text: 'start_blog', target: '_blank', name: 'blog'},
        {text: 'footer_ecommerce', href: '/ecommerce/website', target: '_blank', name: 'ecommerce'},
        {text: 'footer_booking', href: 'https://www.wix.com/scheduling-software', target: '_blank', lang: ['en'], name: 'booking'},
        {text: 'footer_restaurants', href: 'https://www.wix.com/restaurant/website', target: '_blank', lang: ['en'], name: 'restaurants'},
        {text: 'footer_app_market', href: '/app-market', target: '_blank', name: 'app_market'},
        {text: 'footer_domains', href: '/domain/names', target: '_blank', name: 'domains'},
        {text: 'footer_mailboxes', href: '/business/email-address', name: 'mailboxes', target: '_blank', lang: ['en']},
        {text: 'footer_web_hosting', href: 'https://www.wix.com/free/web-hosting', target: '_blank', name: 'web_hosting'},
        {text: 'footer_answers', href: 'https://www.wixanswers.com', target: '_blank', name: 'answers'},
        {text: 'footer_developers', href: 'https://dev.wix.com', target: '_blank', name: 'developers'},
        {text: 'footer_enterprise', href: 'https://www.wix.com/enterprise', target: '_blank', lang: ['en'], name: 'enterprise'},
        {text: 'footer_shoutout', href: 'https://www.wix.com/ascend/email-marketing', target: '_blank', name: 'shoutout'},
        {text: 'footer_design', href: 'https://www.wix.com/website/design', target: '_blank', lang: ['en', 'es', 'de', 'ru'], name: 'footer_design'},
        {text: 'footer_mailboxes', href: '/business/email-address', name: 'footer_mailboxes', target: '_blank', lang: ['de', 'zh', 'es', 'nl', 'no', 'pl', 'pt', 'ru', 'it', 'sv', 'ja', 'ko', 'tr', 'da', 'hi', 'cs', 'th', 'fr']},
      ],
    },
    {
      text: 'footer_company',
      name: 'company',
      subs: [
        {text: 'footer_about_wix', href: '/about/us', target: '_blank', name: 'about'},
        {text: 'footer_press_room', href: 'https://www.wix.com/press-room/home', target: '_blank', lang: ['en'], name: 'press_room'},
        {text: 'footer_investor_relations', href: 'https://investors.wix.com/', target: '_blank', name: 'investor_relations'},
        {text: 'footer_jobs', href: 'https://www.wix.com/jobs/home', target: '_blank', name: 'jobs'},
        {text: 'footer_design_assets', href: '/about/design-assets', target: '_blank', name: 'design_assets'},
        {text: 'footer_terms_of_use', href: '/about/terms-of-use', target: '_blank', name: 'terms_of_use'},
        {text: 'footer_app_market_terms', href: '/about/app-market-terms', target: '_blank', name: 'app_market_terms'},
        {text: 'footer_privacy', href: '/about/privacy', target: '_blank', name: 'privacy'},
        {text: 'footer_a11y', href: '/about/terms-accessibility', target: '_blank', name: 'a11y'},
        {text: 'footer_abuse', href: 'https://www.wix.com/about/abuse', target: '_blank', name: 'abuse'},
        {text: 'footer_affiliates', href: '/about/affiliates', target: '_blank', name: 'affiliates'},
        {text: 'footer_wix_capital', href: 'https://www.wix.com/wix-capital', target: '_blank', lang: ['en'], name: 'wix_capital'},
        {text: 'footer_update_and_release', href: '/release/notes', target: '_blank', name: 'update_and_release'},
        {text: 'footer_contact_us', href: '/about/contact-us', target: '_blank', name: 'contact_us'},
        {text: 'footer_patent_notice', href: '/about/patent-notice', target: '_blank', name: 'patent_notice'},
        {text: 'footer_sitemap', href: '/about/sitemap', target: '_blank', name: 'sitemap'},
      ],
    },
    {
      text: 'footer_community',
      name: 'community',
      subs: [
        {text: 'wix_blog', target: '_blank', name: 'blog'},
        {text: 'footer_wix_marketplace', href: 'https://www.wix.com/marketplace', target: '_blank', name: 'wix_marketplace'},
        {text: 'footer_student', href: '/students', target: '_blank', lang: ['en', 'es', 'fr', 'de', 'nl', 'it'], name: 'student'},
        {text: 'footer_encyclopedia', href: 'https://www.wix.com/encyclopedia', target: '_blank', lang: ['en'], name: 'encyclopedia'},
        {text: 'footer_partner_community', href: 'https://community.wix.com/partners', target: '_blank', lang: ['en', 'ja'], name: 'partner_community'}
      ],
    },
    {
      text: 'menu_support',
      name: 'support',
      subs: [
        {text: 'footer_support_center', href: 'https://support.wix.com/en/', target: '_blank', name: 'support_center'},
        {text: 'footer_status_page', href: 'https://status.wix.com', target: '_blank', name: 'status_page'},
      ],
    },
  ],
};
